import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: 400,
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  drawerInner: {
    display: "grid",
    gridTemplateRows: "56px 1px 1fr 1px 64px",
    height: "100%",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(0, 2),
  },
  drawerBody: {
    overflowY: "auto",
    padding: theme.spacing(2),
  },
  drawerFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    padding: theme.spacing(0, 2),
  },
  sliderLabel: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  sliderRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  sliderValue: {
    minWidth: 24,
    textAlign: "right",
    fontWeight: 600,
  },
}));
